// 銷售週期管理系統資料模型
// Sales Cycle Management System Data Model

// 客戶管理資料
export const customers = [
  {
    id: 'cust-001',
    customer_code: 'CUST-001',
    company_name: '台灣電子科技股份有限公司',
    company_name_en: 'Taiwan Electronics Technology Co., Ltd.',
    industry: 'electronics',
    industry_name: '電子製造業',
    business_type: 'manufacturer',
    company_size: 'large',
    annual_revenue: 5000000000,
    employee_count: 1200,
    established_date: '1998-03-15',
    tax_id: '12345678',
    website: 'https://www.taiwanelectronics.com.tw',
    status: 'active',
    credit_rating: 'A+',
    credit_limit: 10000000,
    payment_terms: '30天',
    currency: 'TWD',
    contacts: [
      {
        id: 'contact-001',
        name: '陳總經理',
        title: '總經理',
        department: '管理部',
        email: 'ceo@taiwanelectronics.com.tw',
        phone: '+886-2-2345-6789',
        mobile: '+886-912-345-678',
        is_primary: true,
        decision_maker: true
      },
      {
        id: 'contact-002',
        name: '李採購經理',
        title: '採購經理',
        department: '採購部',
        email: 'procurement@taiwanelectronics.com.tw',
        phone: '+886-2-2345-6790',
        mobile: '+886-912-345-679',
        is_primary: false,
        decision_maker: false
      }
    ],
    addresses: [
      {
        id: 'addr-001',
        type: 'headquarters',
        address: '台北市信義區松仁路100號12樓',
        city: '台北市',
        state: '台北市',
        country: '台灣',
        postal_code: '110',
        is_primary: true
      },
      {
        id: 'addr-002',
        type: 'factory',
        address: '桃園市龜山區工業一路88號',
        city: '桃園市',
        state: '桃園市',
        country: '台灣',
        postal_code: '333',
        is_primary: false
      }
    ],
    sales_history: {
      total_orders: 45,
      total_revenue: 125000000,
      avg_order_value: 2777778,
      first_order_date: '2020-06-15',
      last_order_date: '2025-01-15',
      ytd_revenue: 15000000,
      ytd_orders: 8
    },
    preferences: {
      preferred_payment_method: 'bank_transfer',
      preferred_shipping_method: 'express',
      communication_language: 'zh-TW',
      special_requirements: '需要中文發票和收據'
    },
    created_at: '2020-06-01T09:00:00',
    updated_at: '2025-01-20T14:30:00'
  },
  {
    id: 'cust-002',
    customer_code: 'CUST-002',
    company_name: '香港創新科技有限公司',
    company_name_en: 'Hong Kong Innovation Technology Limited',
    industry: 'technology',
    industry_name: '科技服務業',
    business_type: 'service',
    company_size: 'medium',
    annual_revenue: 800000000,
    employee_count: 350,
    established_date: '2015-08-20',
    tax_id: 'HK98765432',
    website: 'https://www.hkinnotech.com',
    status: 'active',
    credit_rating: 'A',
    credit_limit: 5000000,
    payment_terms: '45天',
    currency: 'HKD',
    contacts: [
      {
        id: 'contact-003',
        name: 'Wong Managing Director',
        title: 'Managing Director',
        department: 'Management',
        email: 'md@hkinnotech.com',
        phone: '+852-2345-6789',
        mobile: '+852-9123-4567',
        is_primary: true,
        decision_maker: true
      }
    ],
    addresses: [
      {
        id: 'addr-003',
        type: 'headquarters',
        address: '香港中環金融街88號30樓',
        city: '香港',
        state: '香港',
        country: '香港',
        postal_code: '999077',
        is_primary: true
      }
    ],
    sales_history: {
      total_orders: 28,
      total_revenue: 85000000,
      avg_order_value: 3035714,
      first_order_date: '2021-03-10',
      last_order_date: '2025-01-10',
      ytd_revenue: 12000000,
      ytd_orders: 5
    },
    preferences: {
      preferred_payment_method: 'letter_of_credit',
      preferred_shipping_method: 'air_freight',
      communication_language: 'en-US',
      special_requirements: 'English documentation required'
    },
    created_at: '2021-03-01T10:00:00',
    updated_at: '2025-01-18T16:45:00'
  },
  {
    id: 'cust-003',
    customer_code: 'CUST-003',
    company_name: '新加坡電子工業私人有限公司',
    company_name_en: 'Singapore Electronics Industries Pte Ltd',
    industry: 'manufacturing',
    industry_name: '製造業',
    business_type: 'manufacturer',
    company_size: 'large',
    annual_revenue: 2000000000,
    employee_count: 800,
    established_date: '2010-11-05',
    tax_id: 'SG12345678A',
    website: 'https://www.sgelectronics.com.sg',
    status: 'active',
    credit_rating: 'A+',
    credit_limit: 8000000,
    payment_terms: '60天',
    currency: 'SGD',
    contacts: [
      {
        id: 'contact-004',
        name: 'Tan CEO',
        title: 'Chief Executive Officer',
        department: 'Executive',
        email: 'ceo@sgelectronics.com.sg',
        phone: '+65-6234-5678',
        mobile: '+65-9123-4567',
        is_primary: true,
        decision_maker: true
      }
    ],
    addresses: [
      {
        id: 'addr-004',
        type: 'headquarters',
        address: '1 Marina Bay Sands, Singapore 018956',
        city: 'Singapore',
        state: 'Singapore',
        country: 'Singapore',
        postal_code: '018956',
        is_primary: true
      }
    ],
    sales_history: {
      total_orders: 32,
      total_revenue: 180000000,
      avg_order_value: 5625000,
      first_order_date: '2019-09-20',
      last_order_date: '2025-01-08',
      ytd_revenue: 25000000,
      ytd_orders: 6
    },
    preferences: {
      preferred_payment_method: 'bank_transfer',
      preferred_shipping_method: 'sea_freight',
      communication_language: 'en-US',
      special_requirements: 'Quarterly business reviews required'
    },
    created_at: '2019-09-01T11:00:00',
    updated_at: '2025-01-15T09:30:00'
  }
];

// 潛在客戶追蹤資料
export const leads = [
  {
    id: 'lead-001',
    lead_code: 'LEAD-001',
    company_name: '日本精密工業株式會社',
    company_name_en: 'Japan Precision Industries Co., Ltd.',
    industry: 'precision_manufacturing',
    industry_name: '精密製造業',
    lead_source: 'trade_show',
    lead_source_detail: '2025台北國際工業展',
    status: 'qualified',
    score: 85,
    priority: 'high',
    estimated_value: 15000000,
    estimated_close_date: '2025-03-15',
    probability: 75,
    stage: 'proposal',
    contact_person: '田中部長',
    contact_title: '採購部長',
    contact_email: 'tanaka@jprecision.co.jp',
    contact_phone: '+81-3-1234-5678',
    address: '東京都港區六本木1-1-1',
    country: '日本',
    assigned_to: '王業務經理',
    next_action: 'follow_up_proposal',
    next_action_date: '2025-01-25',
    notes: '對我們的精密零件產品線很感興趣，已提供初步報價',
    interactions: [
      {
        id: 'interaction-001',
        type: 'meeting',
        date: '2025-01-15',
        subject: '產品介紹會議',
        notes: '介紹公司產品線，客戶表示高度興趣',
        next_steps: '提供詳細報價單'
      },
      {
        id: 'interaction-002',
        type: 'email',
        date: '2025-01-18',
        subject: '報價單寄送',
        notes: '已寄送詳細報價單和產品規格',
        next_steps: '等待客戶回覆'
      }
    ],
    created_at: '2025-01-15T10:30:00',
    updated_at: '2025-01-20T14:15:00'
  },
  {
    id: 'lead-002',
    lead_code: 'LEAD-002',
    company_name: '韓國電子材料有限公司',
    company_name_en: 'Korea Electronic Materials Ltd.',
    industry: 'electronics',
    industry_name: '電子材料業',
    lead_source: 'website',
    lead_source_detail: '官網詢價表單',
    status: 'new',
    score: 45,
    priority: 'medium',
    estimated_value: 8000000,
    estimated_close_date: '2025-04-30',
    probability: 35,
    stage: 'initial_contact',
    contact_person: '金經理',
    contact_title: '採購經理',
    contact_email: 'kim@kematerials.co.kr',
    contact_phone: '+82-2-1234-5678',
    address: '首爾市江南區테헤란로 123',
    country: '韓國',
    assigned_to: '李業務專員',
    next_action: 'schedule_meeting',
    next_action_date: '2025-01-28',
    notes: '透過網站詢價，需要電子材料相關產品',
    interactions: [
      {
        id: 'interaction-003',
        type: 'email',
        date: '2025-01-22',
        subject: '初次聯繫',
        notes: '回覆網站詢價，安排後續會議',
        next_steps: '確認會議時間'
      }
    ],
    created_at: '2025-01-22T09:15:00',
    updated_at: '2025-01-22T16:30:00'
  },
  {
    id: 'lead-003',
    lead_code: 'LEAD-003',
    company_name: '美國科技解決方案公司',
    company_name_en: 'US Technology Solutions Inc.',
    industry: 'technology',
    industry_name: '科技服務業',
    lead_source: 'referral',
    lead_source_detail: '現有客戶推薦',
    status: 'qualified',
    score: 92,
    priority: 'high',
    estimated_value: 25000000,
    estimated_close_date: '2025-02-28',
    probability: 90,
    stage: 'negotiation',
    contact_person: 'John Smith',
    contact_title: 'VP of Procurement',
    contact_email: 'john.smith@ustechsol.com',
    contact_phone: '+1-555-123-4567',
    address: '123 Tech Street, Silicon Valley, CA 94000',
    country: '美國',
    assigned_to: '張業務總監',
    next_action: 'contract_negotiation',
    next_action_date: '2025-01-26',
    notes: '大型訂單機會，正在進行合約談判',
    interactions: [
      {
        id: 'interaction-004',
        type: 'meeting',
        date: '2025-01-20',
        subject: '合約條款討論',
        notes: '討論價格和交貨條件，接近成交',
        next_steps: '準備最終合約'
      }
    ],
    created_at: '2025-01-10T11:00:00',
    updated_at: '2025-01-21T10:45:00'
  }
];

// 市場分析資料
export const marketAnalysis = {
  market_overview: {
    total_market_size: 50000000000,
    market_growth_rate: 8.5,
    market_segments: [
      {
        segment: 'electronics',
        segment_name: '電子製造業',
        market_share: 35,
        growth_rate: 12.3,
        size: 17500000000
      },
      {
        segment: 'automotive',
        segment_name: '汽車製造業',
        market_share: 25,
        growth_rate: 6.8,
        size: 12500000000
      },
      {
        segment: 'aerospace',
        segment_name: '航太工業',
        market_share: 20,
        growth_rate: 15.2,
        size: 10000000000
      },
      {
        segment: 'medical',
        segment_name: '醫療器材業',
        market_share: 12,
        growth_rate: 9.5,
        size: 6000000000
      },
      {
        segment: 'others',
        segment_name: '其他產業',
        market_share: 8,
        growth_rate: 4.2,
        size: 4000000000
      }
    ]
  },
  competitive_analysis: [
    {
      competitor: 'CompetitorA',
      competitor_name: '競爭對手A',
      market_share: 28,
      strengths: ['價格競爭力', '廣泛通路', '品牌知名度'],
      weaknesses: ['產品創新不足', '客戶服務品質', '交貨時間'],
      key_customers: ['大型製造商', '系統整合商'],
      pricing_strategy: 'cost_leadership'
    },
    {
      competitor: 'CompetitorB',
      competitor_name: '競爭對手B',
      market_share: 22,
      strengths: ['技術創新', '高品質產品', '專業服務'],
      weaknesses: ['價格較高', '市場覆蓋不足'],
      key_customers: ['高端製造商', '研發機構'],
      pricing_strategy: 'differentiation'
    },
    {
      competitor: 'CompetitorC',
      competitor_name: '競爭對手C',
      market_share: 15,
      strengths: ['區域優勢', '客戶關係', '快速響應'],
      weaknesses: ['產品線有限', '規模經濟不足'],
      key_customers: ['中小企業', '區域客戶'],
      pricing_strategy: 'focus'
    }
  ],
  market_trends: [
    {
      trend: 'digital_transformation',
      trend_name: '數位轉型',
      impact: 'high',
      description: '客戶需求更智能化的解決方案',
      opportunity: '開發智能產品線'
    },
    {
      trend: 'sustainability',
      trend_name: '永續發展',
      impact: 'medium',
      description: '環保和綠色製造趨勢',
      opportunity: '推出環保產品'
    },
    {
      trend: 'customization',
      trend_name: '客製化需求',
      impact: 'high',
      description: '客戶需要更多客製化解決方案',
      opportunity: '提供客製化服務'
    }
  ],
  regional_analysis: [
    {
      region: 'asia_pacific',
      region_name: '亞太地區',
      market_share: 45,
      growth_rate: 11.2,
      key_countries: ['中國', '日本', '韓國', '台灣'],
      opportunities: ['製造業回流', '供應鏈重組']
    },
    {
      region: 'north_america',
      region_name: '北美地區',
      market_share: 30,
      growth_rate: 7.8,
      key_countries: ['美國', '加拿大'],
      opportunities: ['高端製造', '技術創新']
    },
    {
      region: 'europe',
      region_name: '歐洲地區',
      market_share: 20,
      growth_rate: 5.5,
      key_countries: ['德國', '法國', '英國'],
      opportunities: ['工業4.0', '綠色製造']
    }
  ]
};

// 定價工具資料
export const pricingTools = {
  cost_structure: {
    material_cost_percentage: 45,
    labor_cost_percentage: 25,
    overhead_cost_percentage: 20,
    profit_margin_percentage: 10
  },
  pricing_models: [
    {
      model: 'cost_plus',
      model_name: '成本加成定價',
      description: '基於成本加上固定利潤率',
      formula: '成本 × (1 + 利潤率)',
      use_case: '標準產品定價'
    },
    {
      model: 'value_based',
      model_name: '價值導向定價',
      description: '基於客戶價值認知定價',
      formula: '客戶價值 × 價值分享比例',
      use_case: '高價值解決方案'
    },
    {
      model: 'competitive',
      model_name: '競爭導向定價',
      description: '基於競爭對手價格定價',
      formula: '競爭對手價格 ± 差異化調整',
      use_case: '競爭激烈市場'
    }
  ],
  discount_policies: [
    {
      type: 'volume_discount',
      name: '數量折扣',
      tiers: [
        { min_quantity: 100, max_quantity: 499, discount_rate: 3 },
        { min_quantity: 500, max_quantity: 999, discount_rate: 5 },
        { min_quantity: 1000, max_quantity: 9999, discount_rate: 8 },
        { min_quantity: 10000, max_quantity: null, discount_rate: 12 }
      ]
    },
    {
      type: 'payment_terms_discount',
      name: '付款條件折扣',
      options: [
        { terms: '預付款', discount_rate: 3 },
        { terms: '15天內付款', discount_rate: 2 },
        { terms: '30天內付款', discount_rate: 0 },
        { terms: '60天內付款', discount_rate: -2 }
      ]
    },
    {
      type: 'seasonal_discount',
      name: '季節性折扣',
      periods: [
        { period: 'Q1', discount_rate: 5 },
        { period: 'Q2', discount_rate: 2 },
        { period: 'Q3', discount_rate: 0 },
        { period: 'Q4', discount_rate: 8 }
      ]
    }
  ],
  price_lists: [
    {
      product_id: 'prod-001',
      product_name: '精密電子零件A',
      standard_price: 1500,
      cost: 1200,
      margin: 300,
      margin_percentage: 20,
      competitor_prices: [
        { competitor: 'CompetitorA', price: 1450 },
        { competitor: 'CompetitorB', price: 1600 },
        { competitor: 'CompetitorC', price: 1520 }
      ]
    },
    {
      product_id: 'prod-002',
      product_name: '高性能處理器B',
      standard_price: 2800,
      cost: 2200,
      margin: 600,
      margin_percentage: 21.4,
      competitor_prices: [
        { competitor: 'CompetitorA', price: 2750 },
        { competitor: 'CompetitorB', price: 2950 },
        { competitor: 'CompetitorC', price: 2820 }
      ]
    }
  ]
};

// 合約管理資料
export const contracts = [
  {
    id: 'contract-001',
    contract_number: 'CNT-2025-001',
    customer_id: 'cust-001',
    customer_name: '台灣電子科技股份有限公司',
    contract_type: 'sales',
    contract_value: 15000000,
    currency: 'TWD',
    start_date: '2025-01-01',
    end_date: '2025-12-31',
    status: 'active',
    payment_terms: '30天',
    delivery_terms: 'FOB Taiwan',
    warranty_period: '12個月',
    key_terms: [
      {
        term: 'minimum_order',
        description: '最低訂購量',
        value: '每月至少100萬元'
      },
      {
        term: 'price_protection',
        description: '價格保護',
        value: '6個月內價格不調漲'
      },
      {
        term: 'exclusive_territory',
        description: '獨家區域',
        value: '台灣地區獨家代理'
      }
    ],
    milestones: [
      {
        milestone: 'contract_signing',
        date: '2025-01-01',
        status: 'completed',
        description: '合約簽署'
      },
      {
        milestone: 'first_delivery',
        date: '2025-01-15',
        status: 'completed',
        description: '首批交貨'
      },
      {
        milestone: 'mid_year_review',
        date: '2025-06-30',
        status: 'pending',
        description: '年中檢討'
      }
    ],
    documents: [
      {
        document_type: 'main_contract',
        file_name: '主合約_CNT-2025-001.pdf',
        uploaded_at: '2025-01-01T10:00:00'
      },
      {
        document_type: 'amendment',
        file_name: '修訂條款_CNT-2025-001-A1.pdf',
        uploaded_at: '2025-01-15T14:30:00'
      }
    ],
    created_at: '2025-01-01T09:00:00',
    updated_at: '2025-01-15T14:30:00'
  }
];

// 信用檢查資料
export const creditChecks = [
  {
    id: 'credit-001',
    customer_id: 'cust-001',
    customer_name: '台灣電子科技股份有限公司',
    check_date: '2025-01-15',
    check_type: 'annual_review',
    credit_limit_requested: 12000000,
    credit_limit_approved: 10000000,
    credit_rating: 'A+',
    risk_level: 'low',
    payment_history: {
      on_time_payments: 95,
      late_payments: 5,
      average_days_late: 3,
      total_transactions: 120
    },
    financial_indicators: {
      current_ratio: 2.5,
      debt_to_equity: 0.3,
      revenue_growth: 12.5,
      profit_margin: 8.2
    },
    external_ratings: [
      {
        agency: 'credit_bureau_tw',
        rating: 'AA',
        date: '2024-12-01'
      }
    ],
    recommendations: [
      {
        recommendation: 'approve_credit_limit',
        reason: '財務狀況良好，付款記錄優異'
      }
    ],
    approved_by: '信用部經理',
    approved_at: '2025-01-16T10:30:00',
    valid_until: '2026-01-15',
    created_at: '2025-01-15T09:00:00',
    updated_at: '2025-01-16T10:30:00'
  }
];

// 交貨管理資料
export const deliveries = [
  {
    id: 'delivery-001',
    delivery_number: 'DEL-2025-001',
    sales_order_id: 'so-2025-001',
    customer_id: 'cust-001',
    customer_name: '台灣電子科技股份有限公司',
    delivery_date: '2025-01-20',
    delivery_status: 'delivered',
    shipping_method: 'express',
    tracking_number: 'TRK123456789',
    carrier: '順豐快遞',
    delivery_address: '台北市信義區松仁路100號12樓',
    items: [
      {
        product_id: 'prod-001',
        product_name: '精密電子零件A',
        quantity: 50,
        unit: '個',
        delivered_quantity: 50,
        packaging: '防靜電包裝'
      }
    ],
    delivery_notes: '客戶指定上午交貨',
    proof_of_delivery: 'POD-2025-001.pdf',
    delivered_by: '張司機',
    received_by: '李收貨員',
    delivery_time: '2025-01-20T10:30:00',
    created_at: '2025-01-18T14:00:00',
    updated_at: '2025-01-20T10:30:00'
  }
];

// 銷售發票管理資料
export const salesInvoices = [
  {
    id: 'invoice-001',
    invoice_number: 'INV-2025-001',
    sales_order_id: 'so-2025-001',
    customer_id: 'cust-001',
    customer_name: '台灣電子科技股份有限公司',
    invoice_date: '2025-01-20',
    due_date: '2025-02-19',
    invoice_type: 'standard',
    status: 'sent',
    total_amount: 125000,
    tax_amount: 6250,
    net_amount: 118750,
    currency: 'TWD',
    payment_terms: '30天',
    items: [
      {
        product_id: 'prod-001',
        product_name: '精密電子零件A',
        quantity: 50,
        unit_price: 1500,
        line_total: 75000,
        tax_rate: 5
      }
    ],
    billing_address: '台北市信義區松仁路100號12樓',
    payment_status: 'pending',
    payment_received: 0,
    balance_due: 125000,
    sent_date: '2025-01-20T15:00:00',
    created_at: '2025-01-20T14:00:00',
    updated_at: '2025-01-20T15:00:00'
  }
];

// 收款追蹤資料
export const paymentTracking = [
  {
    id: 'payment-001',
    invoice_id: 'invoice-001',
    customer_id: 'cust-001',
    customer_name: '台灣電子科技股份有限公司',
    invoice_amount: 125000,
    payment_amount: 0,
    balance: 125000,
    due_date: '2025-02-19',
    days_overdue: 0,
    status: 'current',
    payment_method: 'bank_transfer',
    follow_up_actions: [
      {
        action: 'send_invoice',
        date: '2025-01-20',
        status: 'completed',
        notes: '發票已寄送'
      },
      {
        action: 'reminder_call',
        date: '2025-02-10',
        status: 'scheduled',
        notes: '到期前提醒電話'
      }
    ],
    created_at: '2025-01-20T14:00:00',
    updated_at: '2025-01-20T15:00:00'
  }
];

// 銷售週期儀表板資料
export const salesCycleDashboard = {
  summary: {
    total_customers: 156,
    active_leads: 28,
    qualified_leads: 12,
    total_pipeline_value: 85000000,
    avg_deal_size: 3200000,
    conversion_rate: 68.5,
    avg_sales_cycle: 21,
    ytd_revenue: 180000000,
    ytd_target: 200000000,
    achievement_rate: 90
  },
  phase_performance: [
    {
      phase: 'A',
      phase_name: '潛在客戶識別與開發',
      completion_rate: 100,
      avg_duration: 5,
      success_rate: 85,
      bottlenecks: ['市場資訊不足', '聯絡人難以接觸']
    },
    {
      phase: 'B',
      phase_name: '產品報價與解決方案提案',
      completion_rate: 95,
      avg_duration: 3,
      success_rate: 78,
      bottlenecks: ['技術規格確認', '價格競爭激烈']
    },
    {
      phase: 'C',
      phase_name: '商務談判與銷售訂單確認',
      completion_rate: 70,
      avg_duration: 5,
      success_rate: 65,
      bottlenecks: ['價格談判', '合約條款協商']
    },
    {
      phase: 'D',
      phase_name: '生產安排與產品交付',
      completion_rate: 85,
      avg_duration: 8,
      success_rate: 92,
      bottlenecks: ['生產排程', '物流協調']
    },
    {
      phase: 'E',
      phase_name: '發票開立與款項收取',
      completion_rate: 90,
      avg_duration: 15,
      success_rate: 88,
      bottlenecks: ['客戶付款延遲', '發票處理']
    }
  ],
  recent_activities: [
    {
      type: 'new_lead',
      description: '新增潛在客戶：日本精密工業株式會社',
      date: '2025-01-22',
      value: 15000000
    },
    {
      type: 'proposal_sent',
      description: '提案寄送：韓國電子材料有限公司',
      date: '2025-01-21',
      value: 8000000
    },
    {
      type: 'contract_signed',
      description: '合約簽署：美國科技解決方案公司',
      date: '2025-01-20',
      value: 25000000
    }
  ],
  top_opportunities: [
    {
      customer: '美國科技解決方案公司',
      value: 25000000,
      probability: 90,
      close_date: '2025-02-28',
      stage: 'negotiation'
    },
    {
      customer: '日本精密工業株式會社',
      value: 15000000,
      probability: 75,
      close_date: '2025-03-15',
      stage: 'proposal'
    },
    {
      customer: '韓國電子材料有限公司',
      value: 8000000,
      probability: 35,
      close_date: '2025-04-30',
      stage: 'initial_contact'
    }
  ]
}; 